import {
  ecoleFrancaiseGreen,
  mediumGreen,
  fontFamilyRoboto,
} from '@components/hoc/Theme/Theme.styled';
import styled from 'styled-components';

export const RadioTitleLabel = styled.label`
  font-size: 14px !important;
  font-family: ${fontFamilyRoboto};
  letter-spacing: 0.5px !important;
  color: #222;
  max-width: 310px;
  display: flex;
  cursor: pointer;
  text-align: justify;
  margin: 2px 8px;
  padding-top: 4px;
  ${(props) => (props.$iserror ? 'color:#f11a48' : 'color:#222')};
`;

export const RadioWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  column-gap: 10%;
`;

export const RadioOptionWrapper = styled.div`
  display: flex;
  position: relative;
  box-shadow: 0 1px 3px #00000017;
  border-radius: 5px;
  height: 65px;
  width: 35%;
  padding-left: 5%;
  padding-right: 5%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  ${(props) => (props.$checked ? `border:1px solid ${ecoleFrancaiseGreen}` : 'border: 1px solid #e5e5e5b4')};
`;

export const Radio = styled.input`
  background: transparent;
  border-radius: 2px;
  resize: none;
  display: block;
  height: 20px;
  border: 1px solid #ccc;
  cursor: pointer;
  opacity: 1;
  transform: scale(1.25);

  &:hover {
    opacity: 1;
    accent-color: ${mediumGreen};
  }

  &:checked {
    opacity: 1;
    accent-color: ${ecoleFrancaiseGreen};
  }
`;
